/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { ArticleNoteResponse } from '../models/article-note-response';
import { getArticleNotes } from '../fn/article-notes/get-article-notes';
import { GetArticleNotes$Params } from '../fn/article-notes/get-article-notes';
import { postConsigneeArticleNote } from '../fn/article-notes/post-consignee-article-note';
import { PostConsigneeArticleNote$Params } from '../fn/article-notes/post-consignee-article-note';
import { postConsigneeArticleNoteVisible } from '../fn/article-notes/post-consignee-article-note-visible';
import { PostConsigneeArticleNoteVisible$Params } from '../fn/article-notes/post-consignee-article-note-visible';
import { postConsignorArticleNote } from '../fn/article-notes/post-consignor-article-note';
import { PostConsignorArticleNote$Params } from '../fn/article-notes/post-consignor-article-note';

@Injectable({ providedIn: 'root' })
export class ArticleNotesService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `postConsignorArticleNote()` */
  static readonly PostConsignorArticleNotePath = '/organization-sites/{organizationSiteKey}/consignor/delivery-notes/{deliveryNoteKey}/articles/{articleKey}/notes';

  /**
   * Create consignor article note for an article.
   *
   * Creates one consignor article note while the delivery note is 'open'.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postConsignorArticleNote()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  postConsignorArticleNote$Response(params: PostConsignorArticleNote$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = postConsignorArticleNote(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Create consignor article note for an article.
   *
   * Creates one consignor article note while the delivery note is 'open'.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postConsignorArticleNote$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  postConsignorArticleNote(params: PostConsignorArticleNote$Params, context?: HttpContext): Observable<void> {
    const resp = this.postConsignorArticleNote$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `postConsigneeArticleNote()` */
  static readonly PostConsigneeArticleNotePath = '/organization-sites/{organizationSiteKey}/consignee/delivery-notes/{deliveryNoteKey}/articles/{articleKey}/notes';

  /**
   * Create consignee article note for an article.
   *
   * Creates one consignee article note while the delivery note is 'sent'.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postConsigneeArticleNote()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  postConsigneeArticleNote$Response(params: PostConsigneeArticleNote$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = postConsigneeArticleNote(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Create consignee article note for an article.
   *
   * Creates one consignee article note while the delivery note is 'sent'.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postConsigneeArticleNote$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  postConsigneeArticleNote(params: PostConsigneeArticleNote$Params, context?: HttpContext): Observable<void> {
    const resp = this.postConsigneeArticleNote$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getArticleNotes()` */
  static readonly GetArticleNotesPath = '/organization-sites/{organizationSiteKey}/delivery-notes/{deliveryNoteKey}/articles/{articleKey}/notes';

  /**
   * Get article notes for an article.
   *
   * Returns all article notes for the specified article on a delivery note.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getArticleNotes()` instead.
   *
   * This method doesn't expect any request body.
   */
  getArticleNotes$Response(params: GetArticleNotes$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ArticleNoteResponse>>> {
    const obs = getArticleNotes(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get article notes for an article.
   *
   * Returns all article notes for the specified article on a delivery note.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getArticleNotes$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getArticleNotes(params: GetArticleNotes$Params, context?: HttpContext): Observable<Array<ArticleNoteResponse>> {
    const resp = this.getArticleNotes$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<ArticleNoteResponse>>): Array<ArticleNoteResponse> => r.body)
    );
  }

  /** Path part for operation `postConsigneeArticleNoteVisible()` */
  static readonly PostConsigneeArticleNoteVisiblePath = '/organization-sites/{organizationSiteKey}/consignee/delivery-notes/{deliveryNoteKey}/articles/{articleKey}/notes/{articleNoteKey}/visible';

  /**
   * Make a consignee article note visible to others.
   *
   * Sets a consignee article note from not-visible to visible. This is a
   * one-way operation: a note can only be switched from not-visible to
   * visible, never back. Only the consignee that authored the note can publish it.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postConsigneeArticleNoteVisible()` instead.
   *
   * This method doesn't expect any request body.
   */
  postConsigneeArticleNoteVisible$Response(params: PostConsigneeArticleNoteVisible$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = postConsigneeArticleNoteVisible(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Make a consignee article note visible to others.
   *
   * Sets a consignee article note from not-visible to visible. This is a
   * one-way operation: a note can only be switched from not-visible to
   * visible, never back. Only the consignee that authored the note can publish it.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postConsigneeArticleNoteVisible$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  postConsigneeArticleNoteVisible(params: PostConsigneeArticleNoteVisible$Params, context?: HttpContext): Observable<void> {
    const resp = this.postConsigneeArticleNoteVisible$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
